module.exports = __webpack_public_path__ + "static/media/Pastores.74ddb9ff.jpg";